import {Component, ElementRef, Injector, OnInit} from '@angular/core';
import {FrontendFormComponent} from '@abstract/frontend.form.component';
import {FormControl, FormGroup} from '@angular/forms';
import {PasswordRestoreRequestService} from './password-restore-request.service';

@Component({
    selector: 'app-password-restore-request',
    templateUrl: 'password-restore-request.component.html',
    providers: [
        PasswordRestoreRequestService,
    ]
})

export class PasswordRestoreRequestComponent extends FrontendFormComponent  {

    form = new FormGroup({
        email: new FormControl('')
    });

    public isSent = false;

    constructor(
        injector: Injector,
        public formService: PasswordRestoreRequestService,
    ) {
        super(injector);
    }

    init() {}

    afterSave() {
        this.isPending = false;
        this.isSent = true;
    }

    /**
     * Отключаем уведомление об ошибках в полях, переопределяя родительский метод
     * @param error
     * @returns {null}
     */
    showErrorsNotification(error) {
        return null;
    }
}
